import script from "./TwoFA.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFA.vue?vue&type=script&setup=true&lang=js"

import "./TwoFA.vue?vue&type=style&index=0&id=6a54de46&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a54de46"]])

export default __exports__